module.exports = __webpack_public_path__ + "img/about1.f170fa2d.png";